import { render } from "./ErrorLoad.vue?vue&type=template&id=5e9dea7d"
import script from "./ErrorLoad.vue?vue&type=script&lang=js"
export * from "./ErrorLoad.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__